import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './InvestorType';
import * as actions from './InvestorActions';
import * as investorService from './InvestorServices';
import Swal from 'sweetalert2';

function* fetchInvestorSaga(action) {
    try {
        const response = yield call(investorService.fetchInvestors, action.payload);
        yield put(actions.getInvestorsSuccess(response.data));
    } catch (error) {
        yield put(actions.getInvestorsFailure(error));
    }
}

function* getInvestorByIdSaga(action) {
    try {
        const response = yield call(investorService.fetchInvestorById, action.payload);
        yield put(actions.getInvestorByIdSuccess(response.data));
    } catch (error) {
        yield put(actions.getInvestorsFailure(error));
    }
}

function* getInvestmentViewDetailsSaga(action) {
    try {
        const response = yield call(investorService.fetchInvestmentViewDetails, action.payload);
        yield put(actions.getInvestmentViewDetailsSuccess(response.data));
    } catch (error) {
        yield put(actions.getInvestmentViewDetailsFailure(error));
    }
}

function* getInvestmentDetailsByInvestmentIdSaga(action) {
    try {
        const response = yield call(investorService.fetchInvestmentDetailsByInvestmentId, action.payload);
        yield put(actions.getInvestmentDetailsByInvestmentIdSuccess(response.data));
        // For now, just log the result
    } catch (error) {
        yield put(actions.getInvestmentDetailsByInvestmentIdFailure(error));
    }
}


function* deleteInvestorSaga(action) {
    try {
        yield call(investorService.deleteInvestor, action.payload);
        yield put(actions.deleteInvestorSuccess(action.payload));
        yield put(actions.getInvestorsRequest({
            PageNumber: 1,
            PageSize: 10
        }));
    } catch (error) {
        yield put(actions.deleteInvestorFailure(error));
    }
}

function* saveInvestorSaga(action) {
    try {
        // Extract the request object if it exists, otherwise use the payload directly
        const requestData = action.payload.request || action.payload;
        const response = yield call(investorService.saveInvestor, requestData);
        yield put(actions.saveInvestorSuccess(response.data));
    } catch (error) {
        yield put(actions.saveInvestorFailure(error));
    }
}

function* deleteInvestmentDetailsByInvestorInvestmentIDSaga(action) {
    try {
        const response = yield call(investorService.deleteInvestmentDetailsByInvestorInvestmentID, action.payload);
        yield put(actions.deleteInvestmentDetailsByInvestorInvestmentIDSuccess(response.data));
    } catch (error) {
        yield put(actions.deleteInvestmentDetailsByInvestorInvestmentIDFailure(error));
    }
}

function* getPreferredBulkDataSaga(action) {
    try {
        const response = yield call(investorService.getPreferredBulkData, action.payload);
        yield put(actions.getPreferredBulkDataSuccess(response.data));
    } catch (error) {
        yield put(actions.getPreferredBulkDataFailure(error));
    }
}

function* getCatchUpBulkDataSaga(action) {
    try {
        const response = yield call(investorService.getCatchUpBulkData, action.payload);
        
        const totalRecords = response.data?.totalRecords || 
                           response.data?.TotalRecords || 
                           response.data?.total || 
                           response.data?.Total ||
                           response.data?.count ||
                           response.data?.Count ||
                           0;
        
        yield put(actions.getCatchUpBulkDataSuccess({
            catchUpBulkData: response.data?.catchUpInvestments,
            currentUnitPrice: response.data?.currentUnitPrice,
            totalRecords: totalRecords
        }));
    } catch (error) {
        yield put(actions.getCatchUpBulkDataFailure(error));
    }
}

function* getHoldCoBulkDataSaga(action) {
    try {
        const response = yield call(investorService.getHoldCoBulkData, action.payload);
        
        const totalRecords = response.data?.totalRecords || 
                           response.data?.TotalRecords || 
                           response.data?.total || 
                           response.data?.Total ||
                           response.data?.count ||
                           response.data?.Count ||
                           0;
        
        yield put(actions.getHoldCoBulkDataSuccess({
            holdCoBulkData: response.data?.holdCoInvestments,
            currentUnitPrice: response.data?.currentUnitPrice,
            totalRecords: totalRecords
        }));
    } catch (error) {
        yield put(actions.getHoldCoBulkDataFailure(error));
    }
}

function* savePreferredBulkDataSaga(action) {
    try {
        const { data, callback = () => { } } = action.payload;
        const response = yield call(investorService.savePreferredBulkData, data);
        yield put(actions.savePreferredBulkDataSuccess(response.data));
        callback();
        yield put(actions.getPreferredBulkDataRequest({ 
            modifiedBy: data.modifiedBy,
            PageNumber: 1,
            PageSize: 100
        }));
    } catch (error) {
        yield put(actions.savePreferredBulkDataFailure(error));
    }
}

function* saveCatchUpBulkDataSaga(action) {
    try {
        const { data, callback = () => { } } = action.payload;
        const response = yield call(investorService.saveCatchUpBulkData, data);
        yield put(actions.saveCatchUpBulkDataSuccess(response.data));
        callback();
        yield put(actions.getCatchUpBulkDataRequest({ 
            modifiedBy: data.modifiedBy,
            PageNumber: 1,
            PageSize: 100
        }));
    } catch (error) {
        yield put(actions.saveCatchUpBulkDataFailure(error));
    }
}

function* saveHoldCoBulkDataSaga(action) {
    try {
        const { data, callback = () => { } } = action.payload;
        const response = yield call(investorService.saveHoldCoBulkData, data);
        yield put(actions.saveHoldCoBulkDataSuccess(response.data));
        callback();
        yield put(actions.getHoldCoBulkDataRequest({ 
            modifiedBy: data.modifiedBy,
            PageNumber: 1,
            PageSize: 100
        }));
    } catch (error) {
        yield put(actions.saveHoldCoBulkDataFailure(error));
    }
}
function* exportUserDataSaga(action) {
    try {
        const response = yield call(investorService.exportEquityUserData, action.payload);
        yield put(actions.exportEquityUserDataSuccess(response.data));
    } catch (error) {
        yield put(actions.exportEquityUserDataFailure(error));
    }
}
function* importEquityUserDataSaga(action) {
    try {
        const response = yield call(investorService.importtEquityUserData, action.payload);
        if (response?.status) {
            // Show the real outcome (e.g. "2 of 6 records imported successfully. 4 failed...")
            // instead of a generic message -- partial success is now a normal, expected result,
            // not something to gloss over. See the Equity Imports tab for failure reasons.
            Swal.fire({
                        icon: "success",
                        text: response?.responseMessage || "Import Successful",
                        confirmButtonText: "OK",
                        timer: 5000
                    });
            yield put(actions.importEquityUserDataSuccess(response.data));
        }
        else if(response?.status === false){
         Swal.fire({
                        icon: "error",
                        text: response?.responseMessage || "Import Failed",
                        confirmButtonText: "OK",
                        timer: 5000
                    });
        yield put(actions.importEquityUserDataFailure(response?.data));
    }
    } catch (error) {
        yield put(actions.importEquityUserDataFailure(error));
    }
}

function* fetchEquityImportBatchListSaga(action) {
    try {
        const response = yield call(investorService.fetchEquityImportBatchList, action.payload);
        yield put(actions.fetchEquityImportBatchListSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchEquityImportBatchListFailure(error));
    }
}

function* downloadEquityImportRecordsSaga(action) {
    const importBatchID = action.payload;
    try {
        const response = yield call(investorService.downloadEquityImportRecords, importBatchID);
        const base64 = response?.data || null;
        if (base64) {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Equity_Import_Records_${importBatchID}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            yield put(actions.downloadEquityImportRecordsSuccess({ importBatchID }));
        } else {
            yield put(actions.downloadEquityImportRecordsFailure("No file data found"));
            Swal.fire({ icon: "error", text: "Download failed: no records found.", confirmButtonText: "OK" });
        }
    } catch (error) {
        yield put(actions.downloadEquityImportRecordsFailure(error));
        Swal.fire({ icon: "error", text: "Download failed. Please try again.", confirmButtonText: "OK" });
    }
}

function* publishInvestmentSaga(action) {
    try {
        const response = yield call(investorService.publishInvestment, action.payload);
        if (response?.status) {
            Swal.fire({
                icon: 'success',
                text: 'Investment published successfully.',
                confirmButtonText: 'OK',
                timer: 3000,
            });
            yield put(actions.publishInvestmentSuccess(response.data));
        } else {
            Swal.fire({
                icon: 'error',
                text: response?.data?.message || 'Publish failed. Please try again.',
                confirmButtonText: 'OK',
            });
            yield put(actions.publishInvestmentFailure(response?.data));
        }
    } catch (error) {
        Swal.fire({
            icon: 'error',
            text: 'Publish failed. Please try again.',
            confirmButtonText: 'OK',
        });
        yield put(actions.publishInvestmentFailure(error));
    }
}
export default function* watchInvestorSaga() {
    yield takeLatest(types.GET_INVESTORS_REQUEST, fetchInvestorSaga);
    yield takeLatest(types.GET_INVESTOR_BY_ID_REQUEST, getInvestorByIdSaga);
    yield takeLatest(types.GET_INVESTMENT_VIEW_DETAILS_REQUEST, getInvestmentViewDetailsSaga);
    yield takeLatest(types.DELETE_INVESTOR_REQUEST, deleteInvestorSaga);
    yield takeLatest(types.SAVE_INVESTOR_REQUEST, saveInvestorSaga);
    yield takeLatest(types.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_REQUEST, deleteInvestmentDetailsByInvestorInvestmentIDSaga);
    yield takeLatest(types.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_REQUEST, getInvestmentDetailsByInvestmentIdSaga);
    yield takeLatest(types.GET_PREFERRED_BULK_DATA_REQUEST, getPreferredBulkDataSaga);
    yield takeLatest(types.GET_CATCHUP_BULK_DATA_REQUEST, getCatchUpBulkDataSaga);
    yield takeLatest(types.GET_HOLDCO_BULK_DATA_REQUEST, getHoldCoBulkDataSaga);
    yield takeLatest(types.SAVE_PREFERRED_BULK_DATA_REQUEST, savePreferredBulkDataSaga);
    yield takeLatest(types.SAVE_CATCHUP_BULK_DATA_REQUEST, saveCatchUpBulkDataSaga);
    yield takeLatest(types.SAVE_HOLDCO_BULK_DATA_REQUEST, saveHoldCoBulkDataSaga);
    yield takeLatest(types.EXPORT_EQUITY_USER_REQUEST, exportUserDataSaga);
    yield takeLatest(types.IMPORT_EQUITY_USER_REQUEST, importEquityUserDataSaga);
    yield takeLatest(types.PUBLISH_INVESTMENT_REQUEST, publishInvestmentSaga);
    yield takeLatest(types.FETCH_EQUITY_IMPORT_BATCH_LIST_REQUEST, fetchEquityImportBatchListSaga);
    yield takeLatest(types.DOWNLOAD_EQUITY_IMPORT_RECORDS_REQUEST, downloadEquityImportRecordsSaga);
}
